export default __webpack_public_path__ + "static/media/w8.26523c39.png";